import { render, staticRenderFns } from "./sms-campaigns.vue?vue&type=template&id=6583af6f&scoped=true"
import script from "./sms-campaigns.vue?vue&type=script&lang=js"
export * from "./sms-campaigns.vue?vue&type=script&lang=js"
import style0 from "./sms-campaigns.vue?vue&type=style&index=0&id=6583af6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6583af6f",
  null
  
)

export default component.exports